_ = require("lodash")

class ScoreCardInfoCtrl
  constructor: (@$scope, @ScoreCardParser, @ScoreDataHolderService) ->
    @$scope.$watch (=> @ScoreDataHolderService.players), =>
      return unless @ScoreDataHolderService.roundInfo
      @_setScoresData()

    @$scope.$watch (=> @ScoreDataHolderService.roundInfo), =>
      return unless @ScoreDataHolderService.roundInfo
      @_setScoresData()

  onScoresUpdated: (players, boardType) =>
    return if not players

    for p, i in @players
      @_updateScores(p, players[i].scores, boardType)

  _updateScores: (player, newScores, inOrOut) ->
    if inOrOut is 'out'
      _.forEach newScores, (s, i) -> player.scores[i] = s
    else if inOrOut is 'in'
      _.forEach newScores, (s, i) -> player.scores[i + 9] = s
    else
      _.forEach newScores, (s, i) -> player.scores_extra[i] = s

  _setScoresData: ->
    @course = @ScoreDataHolderService.roundInfo.course
    @course_extra = @ScoreDataHolderService.roundInfo.course_extra
    @holes = @ScoreDataHolderService.roundInfo.holes
    @holes_extra = @ScoreDataHolderService.roundInfo.holes_extra
    @tee =  @ScoreDataHolderService.roundInfo.tee
    @tee_extra =  @ScoreDataHolderService.roundInfo.tee_extra
    @players = @ScoreDataHolderService.players
    @extra_9 = @ScoreDataHolderService.roundInfo.extra_9
    @extra_9 = true if @ScoreDataHolderService.roundInfo.has_extra

    roundInfo =
      tee: @tee
      tee_extra: @tee_extra
      extra_9: @extra_9
      holes: @holes
      holes_extra: @holes_extra
      players: @players


    @inScoreCardInfo = @ScoreCardParser.parseInViewModel roundInfo if @holes.length is 18
    @outScoreCardInfo = @ScoreCardParser.parseOutViewModel roundInfo
    @extraScoreCardInfo = @ScoreCardParser.parseScoreCardExtraBoard roundInfo if roundInfo.extra_9

ScoreCardInfoCtrl.$inject = [
  '$scope'
  'ScoreCardParser'
  'ScoreDataHolderService'
]

module.exports = ScoreCardInfoCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/score-registration/score-card-info/score-card-info-controller.coffee